import { Component, Input } from '@angular/core';

import { BarChartDatePeriod } from '../../../../tms-shared';
import { ChartWeeksPurchaseInvoiceService } from '../../../services';

@Component({
  selector: 'app-purchase-invoice-chart',
  templateUrl: './purchase-invoice-chart.component.html',
  styleUrl: './purchase-invoice-chart.component.scss',
})
export class PurchaseInvoiceChartComponent {
  @Input() supplierId: string = '';
  @Input() barChartPeriod: BarChartDatePeriod = BarChartDatePeriod.Week;
  @Input() xRotation: number = 0;

  readonly yNamePurchaseValue = $localize`Purchase Value`;

  constructor(public chartWeeksPurchaseInvoicesService: ChartWeeksPurchaseInvoiceService) {}
}
